import React from 'react';
import FormFieldTextOrNumber from '../../../../../../components/formFields/FormFieldTextOrNumber';
import { useIntl } from 'react-intl';

/**
 * @typedef PriceEditorProperties
 * @property {Connectico.ProductPrices} values
 * @property {{ mutators: { setNetPrice: (index: number, netPrice: string) => void } }} form
 * @property {number} index
 * @property {(grossPrice: number | null, taxId: number | null) => string | undefined} calculateNetPrice
 * @property {number} max
 * @property {boolean} disabled
 */

/**
 * @param {PriceEditorProperties} props
 * @returns {JSX.Element}
 */
const PriceEditor = ({ values, form, index, calculateNetPrice, max, disabled }) =>
{
    const translations = useIntl().messages.products.edit.tabs.prices;
    return (
        <div className='flex-wrap flex-md-nowrap d-inline-flex justify-content-between w-100 mt-3' >
            <FormFieldTextOrNumber
                label={translations.inputs.grossPrice}
                min={0}
                step='0.01'
                name={`prices[${index}].grossPrice`}
                type='number'
                mutator={(value) => form.mutators.setNetPrice(index, calculateNetPrice(value, values.Tax))}
                parse={value => value ? parseFloat(value) : null}
                className='w-100'
                max={max}
                disabled={disabled}
            />
            <FormFieldTextOrNumber
                label={translations.inputs.netPrice}
                min={0}
                type='number'
                name={`prices[${index}].netPrice`}
                disabled
                parse={value => value ? parseFloat(value) : null}
                className='w-100 pl-md-3'
            />
        </div>
    );
};

export default PriceEditor;